import { render, staticRenderFns } from "./level.vue?vue&type=template&id=6c78f7de"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c78f7de')) {
      api.createRecord('6c78f7de', component.options)
    } else {
      api.reload('6c78f7de', component.options)
    }
    module.hot.accept("./level.vue?vue&type=template&id=6c78f7de", function () {
      api.rerender('6c78f7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/level.vue"
export default component.exports